import { moment } from 'src/common/types';
import { DateRange, PagedRequest, PagedResult } from '../../../../../store';
import { ClientPortfolio } from '../../common/store/types';

export interface TransactionsState {
  parameters: TransactionsParameters;
  totals: TransactionsTotals | null;
  transactions: PagedResult<Transaction> | null;
  selectedTransaction: TransactionDetails | null;
}

export interface TransactionsParameters {
  pagination: PagedRequest;
  portfolio: ClientPortfolio | null;
  selectedAccountId: number | null;
  accountIdList: number[];
  securityGroupOpt: string;
  dates: DateRange;
  transactionId: number | null;
}

export enum SecurityGroupOption {
  All = 'All',
  Cash = 'Cash',
  Investment = 'Investment',
}

export interface ThunkParameters {
  clientId: number;
  parameters: TransactionsParameters;
}

export interface FetchTransactionDetailsParameters {
  clientId: number;
  transactionId: number;
}

export interface Transaction {
  id: number;
  accountId: number;
  accountNumber: string;
  securityCode: string;
  securityName: string;
  tradeDate: moment;
  units: number | null;
  unitPrice: number | null;
  transactionValue: number | null;
  systemTransactionType: string;
  comments: string;
}

export interface TransactionsTotals {
  purchases: number;
  sales: number;
  corporateActions: number;
  income: number;
}

export interface FeeAndAdjustmentDetails {
  type: string;
  fee: number | null;
  gst: number | null;
  total: number | null;
  nativeFee: number | null;
  nativeGst: number | null;
  nativeTotal: number | null;
}

export interface TransactionDetails {
  id: number;
  accountId: number;
  accountNumber: string;
  securityCode: string;
  securityName: string;
  tradeDate: moment | undefined;
  units: number | null;
  unitPrice: number | null;
  transactionValue: number | null;
  systemTransactionType: string;
  comments: string;
  taxDate: moment | undefined;
  settlementDate: moment | undefined;
  brokerage: number | null;
  brokerageGst: number | null;
  unitPriceNative: number | null;
  transactionValueNative: number | null;
  fxRate: number | null;
  fxRateType: string | null;
  currencyNative: string | null;
  currencyQuote: string | null;
  costBaseOverride: number | null;
  transactionValueBeforeFees: number | null;
  transactionValueBeforeFeesNative: number | null;
  totalFeeAmount: number | null;
  totalFeeGst: number | null;
  totalFeeAmountNative: number | null;
  totalFeeGstNative: number | null;
  totalFeesAndCharges: number | null;
  totalFeesAndChargesNative: number | null;
  feeAndAdjustmentDetails: FeeAndAdjustmentDetails[];
}

export interface FetchTransactionsPayload {
  inputs: ThunkParameters;
  pagination: PagedRequest;
}

export interface DownloadTransactionsPayload extends FetchTransactionsPayload {
  mapper: (transactions: Transaction[]) => TransactionCsvRow[];
}

export interface TransactionCsvRow {
  date: string;
  account: string;
  transactionType: string;
  securityCode: string;
  units: number | null;
  price: number | null;
  value: number | null;
  description: string;
}

export interface FeeDetailsRow {
  type: string;
  amount: string;
  gst: string;
  total: string;
}
